import { useTranslations } from 'next-intl';
import { OptumNowLogo } from 'assets/icons/OptumNowLogo';
import styles from './OptumBenefitBanner.module.css';

/** "Members save $100 on Ring PRO, applied in your cart.", under the buy-page price. */
export function OptumBenefitBanner({ className }: { className?: string }) {
  const t = useTranslations('optum');

  return (
    <div className={className ? `${styles.banner} ${className}` : styles.banner}>
      <OptumNowLogo label={t('header.optumLogoAlt')} className={styles.logo} />
      <p className={styles.text}>
        <strong>{t('benefit.title')}</strong>
      </p>
    </div>
  );
}
